import { render, staticRenderFns } from "./FactorGroup.vue?vue&type=template&id=3a1ca9a4&"
import script from "./FactorGroup.vue?vue&type=script&lang=ts&"
export * from "./FactorGroup.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports